import styled from 'styled-components';
var Container = styled.div.withConfig({
  displayName: "Sizesstyles__Container",
  componentId: "j1w7uy-0"
})(["font-weight:", ";font-family:", ";font-size:", ";overflow:hidden;"], function (props) {
  return props.theme.font.weight.regular;
}, function (props) {
  return props.theme.font.family.brand;
}, function (props) {
  return props.theme.font.size.base;
});
var Breadcrumbs = styled.div.withConfig({
  displayName: "Sizesstyles__Breadcrumbs",
  componentId: "j1w7uy-1"
})(["margin:20px 0;font-weight:", ";"], function (props) {
  return props.theme.font.weight.bold;
});
var ResponsiveWrapper = styled.div.withConfig({
  displayName: "Sizesstyles__ResponsiveWrapper",
  componentId: "j1w7uy-2"
})(["overflow:auto;"]);
var Table = styled.table.withConfig({
  displayName: "Sizesstyles__Table",
  componentId: "j1w7uy-3"
})(["margin:40px 0;width:100%;max-width:100%;min-width:440px;display:table;.th{text-align:center;padding:20px;color:", ";background:", ";border:1px solid ", ";}.tr{border-style:solid;background:", ";&:nth-child(odd){background:", ";}.td{padding:20px 10px;text-align:center;border-collapse:collapse;border-style:hidden;border:1px solid ", ";&.row-title{background:", ";color:", ";}}&:hover{background:", ";color:", ";.row-title{background:", ";color:", ";}}}"], function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.color.monochrome.lighter;
}, function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.color.monochrome.lighter;
}, function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.color.monochrome.white;
});
export { Container, Breadcrumbs, ResponsiveWrapper, Table };